/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Senddrafts_Schedule_Confirm2Inputs */

const en_coinvestments_senddrafts_schedule_confirm2 = /** @type {(inputs: Coinvestments_Senddrafts_Schedule_Confirm2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schedule`)
};

/**
* | output |
* | --- |
* | "Schedule" |
*
* @param {Coinvestments_Senddrafts_Schedule_Confirm2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_senddrafts_schedule_confirm2 = /** @type {((inputs?: Coinvestments_Senddrafts_Schedule_Confirm2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Senddrafts_Schedule_Confirm2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_senddrafts_schedule_confirm2(inputs)
});
export { coinvestments_senddrafts_schedule_confirm2 as "coInvestments_sendDrafts_schedule_confirm" }